import {InjectionToken} from '@angular/core';
import {ResourceToDisplay} from '../components/chatbot/customItems/components/quiz-source/resource-to-display';
import {Observable} from 'rxjs';
import {OpenPopupData} from '../../../../micromate-learn-web/src/app/core/OpenPopupData';
import {InsightTabs} from '../components/study-progress/insight-popup/InsightTabs';
import {TimePeriodMode} from './rest/api-types/TimePeriodMode';

export const TAB_NAVIGATION_SERVICE = new InjectionToken<TabNavigationService>('TabNavigationService');

export abstract class TabNavigationService {

    public abstract openPopup$: Observable<OpenPopupData | undefined>;

    public abstract timePeriodMode$: Observable<TimePeriodMode>;

    public abstract isRunningInWidget(): boolean;

    public abstract navigateToChat(addOpenFromNavigationParameter: boolean): void;

    public abstract navigateToBadges(addOpenFromNavigationParameter: boolean): void;

    public abstract navigateToStudyProgress(addOpenFromNavigationParameter: boolean): void;

    public abstract navigateToScoreboard(addOpenFromNavigationParameter: boolean): void;

    public abstract navigateToProfile(addOpenFromNavigationParameter: boolean): void;

    public abstract closeProfile(): void;

    public abstract toggleProfileVisible(): void;

    public abstract shouldNavigateToUrlWhenOpeningResource(): boolean;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public showResource(resourceToShow: ResourceToDisplay): void {
        // nothing to do per default
    }

    public closeResource(): void {
        // nothing to do per default
    }

    public abstract isMicromateResourceUrl(sourceUrl: string): boolean;

    public abstract navigateToInsightPopup(learningPackageId: string): void;

    public abstract navigateToInsightPopupTab(learningPackageId: string, tab: InsightTabs, customParams?: {
        [key: string]: unknown
    }): void;

    public abstract setTimePeriodModeForInsightPopupLearningHistoryTab(learningPackageId: string, timePeriodMode: TimePeriodMode): void ;

    public abstract isChatTabActive(): boolean;

}
